/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{display:inline}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/copy-clipboard/copy-clipboard.component.scss.shim.ngstyle.js.pre-build-optimizer.js